import { _$, $$ } from './utils'

document.addEventListener('DOMContentLoaded', () => {
  // Set nav menu initial attributes.
  const nav = _$('primary-menu')
  if (nav) {
    nav.setAttribute('aria-hidden', 'true')
    nav.style.display = 'none'
  }

  // Adjust all posts grid item header heights.
  const postHeaders = $$('.blog-posts .entry-header')
  if (postHeaders && postHeaders.length) {
    const postMaxHeight = Array.from(postHeaders).map(a => a.offsetHeight).sort((a, b) => a < b)[0]
    postHeaders.forEach(a => {
      a.style.height = `${postMaxHeight}px`
    })
  }
})
